export default "__VITE_ASSET__19668530__"